import { render, staticRenderFns } from "./richtext.vue?vue&type=template&id=fefa7830"
import script from "./richtext.vue?vue&type=script&lang=js"
export * from "./richtext.vue?vue&type=script&lang=js"
import style0 from "./richtext.vue?vue&type=style&index=0&id=fefa7830&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports